import {
  Component,
  EventEmitter,
  HostListener,
  inject,
  OnInit,
  Output,
} from '@angular/core';
import { DropdownComponent } from '../../dropdown/dropdown.component';
import { IconComponent } from '../../icon/icon.component';
import { SidebarToggleInterface } from '../types/sidebarToggle';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { BaseComponent } from '../../base/base.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LogoComponent } from '../logo/logo.component';
import { LangListComponent } from '../lang-list/lang-list.component';
import { GlobalSearchComponent } from '../global-search/global-search.component';
import { AuthService } from 'src/app/auth/components/login/services/auth.service';
import { AUTH } from 'src/app/auth/components/login/types/login.interface';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  standalone: true,
  imports: [
    IconComponent,
    DropdownComponent,
    RouterModule,
    CommonModule,
    TranslateModule,
    LogoComponent,
    LangListComponent,
    GlobalSearchComponent,
  ],
})
export class HeaderComponent extends BaseComponent implements OnInit {
  authService = inject(AuthService);
  translate = inject(TranslateService);
  @Output() toggleCollapseEvent: EventEmitter<SidebarToggleInterface> =
    new EventEmitter();

  collapsed = true;
  screenWidth = 0;
  showNav = false;
  showSearch = false;

  shareYourOpinionUrl = 'https://forms.cloud.microsoft/Pages/DesignPageV2.aspx?origin=NeoPortalPage&subpage=design&id=uL_707kqw0KWxJg2dVy2IhtCWkZP_HZAnjb8oY22rjVUNkFFSzhaSjA0VUtQMDMzVEJKUE5TNjVWNS4u';

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.screenWidth = window.innerWidth;
    if (this.screenWidth <= 1260) {
      this.collapsed = false;
      this.toggleCollapseEvent.emit({
        collapsed: this.collapsed,
        screenWidth: this.screenWidth,
      });
    }
  }

  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    this.toggleCollapseEvent.emit({
      collapsed: this.collapsed,
      screenWidth: this.screenWidth,
    });

    const token = sessionStorage.getItem(AUTH.TOKEN);
    if (token) {
      this.authService.getVendorData();
    }
  }

  toggleCollapse(): void {
    this.collapsed = !this.collapsed;
    this.toggleCollapseEvent.emit({
      collapsed: this.collapsed,
      screenWidth: this.screenWidth,
    });
  }

  logout(): void {
    console.log('logout');
  }
}
